import { render, staticRenderFns } from "./customSwiper.vue?vue&type=template&id=22874a5f&scoped=true&"
import script from "./customSwiper.vue?vue&type=script&lang=js&"
export * from "./customSwiper.vue?vue&type=script&lang=js&"
import style0 from "./customSwiper.vue?vue&type=style&index=0&id=22874a5f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22874a5f",
  null
  
)

export default component.exports